import { render, staticRenderFns } from "./TrinhDuyetBtn.vue?vue&type=template&id=5ea46de2&"
import script from "./TrinhDuyetBtn.vue?vue&type=script&lang=js&"
export * from "./TrinhDuyetBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports